import { IonButton, IonCol, IonContent, IonIcon, IonPage, IonRow, IonText, IonInput, IonSpinner } from "@ionic/react"
import Head from "./Header"
import Sidebar from "./Sidebar"
import DataTable from "react-data-table-component";
import { useEffect, useState, useMemo } from "react";
import service from "../Service/service";
import { useHistory } from "react-router";
import { searchOutline, chevronDownOutline } from "ionicons/icons";
import "./../theme/style2.css"
import Select from "react-select"
import swal from "sweetalert";
import moment from "moment";

const LeaveReport: React.FC = () => {

    const history = useHistory();
    const [Id] = useState(localStorage.getItem("SignupEmpId"));

    useEffect(() => {
        if (Id === null) {
            history.push("/login");
        } else {
        }
    }, [Id, history]);


    const [showDataTable, setShowDataTable] = useState(false);
    const [isLoading, setIsLoading] = useState(false)
    const [data, setData] = useState([]);
    const [filterText, setFilterText] = useState("");
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
    const [business, setBusiness] = useState("");
    const [businessUnitArr, setBusinessUnitArr] = useState([]);

    const [leaveTypeList, setLeaveTypeList] = useState<LeaveType[]>([]);
    interface LeaveType {
        id: string;
        leaveType: string;
    }
    const [leave, setLeave] = useState("");
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");

    //----------Businessunit Autocomplete----------//

    const [selectedOption, setSelectedOption] = useState(null);
    const [inputValue, setInputValue] = useState('');
    const [isFocused, setIsFocused] = useState(false);
    const [menuIsOpen, setMenuIsOpen] = useState(false);


    const handleStateChange = (selectedOption: any) => {
        setSelectedOption(selectedOption);
    };

    const handleInputChange = (inputValue: any) => {
        setInputValue(inputValue);
    };

    const handleMenuOpen = () => {
        setMenuIsOpen(true);
    };

    const handleMenuClose = () => {
        setMenuIsOpen(false);
    };

    const handleFocus = () => {
        setIsFocused(true);
    };

    const handleBlur = () => {
        setIsFocused(false);
    };
    const Placeholder = () => {
        if (inputValue === '' && !selectedOption && !isFocused) {
            return <span style={{ color: "black" }}>Select Business Unit</span>;
        } else {
            return <span style={{ color: "black" }}>Type to Search Here...</span>;
        }
    };
    const DropdownIndicator: any = ({ innerProps, selectProps }: any) => {
        const [isClicked, setIsClicked] = useState(false);

        useEffect(() => {
            if (isClicked && !selectProps.menuIsOpen) {
                setIsClicked(false);
            }
        }, [selectProps.menuIsOpen]);

        let icon;
        if (isClicked || selectProps.menuIsOpen) {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={searchOutline} />;
        } else {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={chevronDownOutline} />;
        }

        const handleIconClick = () => {
            setIsClicked(true);
        };

        return (
            <div {...innerProps}>
                <div onClick={handleIconClick}>{icon}</div>
            </div>
        );
    };
    const options = [
      
        ...businessUnitArr.map((state: any) => ({
            value: state.id,
            label: state.businessUnitName,
        })),
        {
            value: 'all',
            label: 'All',
        },
    ];
    // const handleBusinessUnitChange = (selectedOption: any) => {
    //     console.log(selectedOption.value, "kn");
    //     setBusiness(selectedOption.value);
    // };
    const handleBusinessUnitChange = (selectedOption: any) => {
        if (selectedOption.value === '') {
            setBusiness(''); 
        } else {
            setBusiness(selectedOption.value);
        }
    };
    //----------LeaveType Autocomplete----------//

    const [selectedOption1, setSelectedOption1] = useState(null);
    const [inputValue1, setInputValue1] = useState('');
    const [isFocused1, setIsFocused1] = useState(false);
    const [menuIsOpen1, setMenuIsOpen1] = useState(false);

    const handleStateChange1 = (selectedOption1: any) => {
        setSelectedOption1(selectedOption1);
    };

    const handleInputChange1 = (inputValue1: any) => {
        setInputValue1(inputValue1);
    };

    const handleMenuOpen1 = () => {
        setMenuIsOpen1(true);
    };

    const handleMenuClose1 = () => {
        setMenuIsOpen1(false);
    };

    const handleFocus1 = () => {
        setIsFocused1(true);
    };

    const handleBlur1 = () => {
        setIsFocused1(false);
    };
    const Placeholder1 = () => {
        if (inputValue1 === '' && !selectedOption1 && !isFocused1) {
            return <span style={{ color: "black" }}>Select Leave Type</span>;
        } else {
            return <span style={{ color: "black" }}>Type to Search Here...</span>;
        }
    };

    const DropdownIndicator1: any = ({ innerProps, selectProps }: any) => {
        const [isClicked, setIsClicked] = useState(false);

        useEffect(() => {
            if (isClicked && !selectProps.menuIsOpen) {
                setIsClicked(false);
            }
        }, [selectProps.menuIsOpen]);

        let icon;
        if (isClicked || selectProps.menuIsOpen) {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={searchOutline} />;
        } else {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={chevronDownOutline} />;
        }

        const handleIconClick = () => {
            setIsClicked(true);
        };

        return (
            <div {...innerProps}>
                <div onClick={handleIconClick}>{icon}</div>
            </div>
        );
    };
    const option1 = [
      
        ...leaveTypeList.map((state: any) => ({
            value: state.id,
            label: state.leaveType,
        })),
        {
            value: 'all',
            label: 'All',
        },
    ];
    // const handleLeaveChange = (selectedOption1: any) => {
    //     console.log(selectedOption1.value, "kn");
    //     setLeave(selectedOption1.value);
    // };
    const handleLeaveChange = (selectedOption1: any) => {
        if (selectedOption1.value === '') {
            setLeave('');
        } else {
            setLeave(selectedOption1.value);
        }
    }
    useEffect(() => {
        LoadEmployee();
        GetLeaveType();
    }, []);

      //----------LeaveType Api----------//
      const GetLeaveType = () => {
        service.GetLeaveType()
            .then((response) => {
                if (response.data.Status === "200") {

                    const filteredLeaveTypes = response.data.Data.filter((leaveType: any) => {
                        return leaveType.leaveType !== "Maternity" && leaveType.leaveType !== "Paternity" && leaveType.leaveType !== "Comp Off" && leaveType.leaveType !== "WFH";
                    });
                    setLeaveTypeList(filteredLeaveTypes);
                }
                else {
                    setLeaveTypeList([]);
                }
            });
    }
   //----------Businessunit Api----------//

    const LoadEmployee = () => {
        service.HRViewEmployee()
            .then((response) => {
                ViewAllBusinessunit()
            })

    }
    const ViewAllBusinessunit = () => {
        service.GetAllBusinessUnitDropDown()
            .then((response) => {
                console.log("Bussiness Unit")
                console.log(response);
                if (response.data.Status === "200") {
                    setBusinessUnitArr(response.data.Data)
                }
                else {
                    setBusinessUnitArr([])
                }
            })
    }

    //----------Leavedetails Api----------//

    const Leave = () => {
        if (!fromDate) {
            swal("", "Please select a From Date.", "info");
            return;
        }
    
        if (!toDate) {
            swal("", "Please select a To Date.", "info");
            return;
        } else {
            setIsLoading(true);
            service.LeaveReport(business, fromDate, toDate, leave)
                .then((response) => {
                    console.log(response);
                    if (response.data.Status === "200") {
                        setData(response.data.Data);
                    } else {
                        setData([]);
                        swal("", response.data.Message, "error");
                    }
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                  
                    setTimeout(() => {
                        setIsLoading(false);
                    }, 1000); 
                });
        }
    };

    //----------LeavedetailsPdf Api---------- //

    const Leavepdf = () => {
        if (!fromDate) {
          swal("", "Please select a From Date.", "info");
          return;
        }
      
        if (!toDate) {
          swal("", "Please select a To Date.", "info");
          return;
        }
      
        setIsLoading(true);
      
     

      
        setTimeout(() => {
          service.LeaveReportPdf(business, fromDate, toDate, leave)
            .then((response) => {
              console.log(response);
              if (response.data.Status === "200") {
                setData(response.data.Data);
              }
            })
            .catch((error) => {
              console.error("Error generating PDF:", error);
            })
            .finally(() => {
              setIsLoading(false);
            });
        }, 1000);
      };
      
    
    

    //---------- Datatable show after click search ----------//
    const handleSearch = () => {
        Leave();
        setShowDataTable(true);
      };
     
     //----------LeaveReport Datatable----------//

    const columns: any = [
        {
            name: "S.No",
            selector: (itm: any, i: any) => i + 1,
            sortable: true,
            width: "100px",
        },

        {
            name: "Business Unit",
            selector: (itm: any) => itm.businessUnit,
            width:'150px',
            sortable: true,
            sort: "businessUnitName",

        },
        {
            name: "Employee Name",
            // selector: (itm: any) => itm.name,
            sortable: true,
            sort: "name",
            width: "250px",
            selector: (itm: any) => (
                <>
                    <div className="wrapper_cls">{itm.employeeName}{" ("}{itm.employeeCode}{")"}</div>
                </>
            )
        },

        {
            name: "From Date",
            width: "130px",
            selector: (itm: any) => moment(itm.fromDate).format("DD-MM-YYYY"),
            sortable: true,

        },
        {
            name: "To Date",
            selector: (itm: any) => moment(itm.toDate).format("DD-MM-YYYY"),
            sortable: true,
            width: "120px",

        },
        {
            name: "Days",
            selector: (itm: any) => itm.days,
            sortable: true,
            width: "90px",
           
        },
        {
            name:"Balance",
            selector:(itm:any) => itm.balance,
            sortable:true,
            width: "125px",
        },
        {
            name: 'Status',
            width: "125px",
            selector: (itm:any) => itm.status,
            sortable: true,
            cell: (itm:any) => (
                <div style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                  {itm.status === "Open" ? (
                    <p style={{ color: "#00b700", margin: '0' }}>Open</p>
                  ) : (
                    <p style={{ color: "red", margin: '0' }}></p>
                  )}
                </div>
              )
              
        },
        {
            name: "Remarks",
            selector: (itm: any) => (itm.remarks !== null && itm.remarks !== undefined && itm.remarks !== "") ? itm.remarks : "",
            sortable: true,
        }
    ];

    const customStyles = {
        headRow: {
              style: {
              },
        },
        headCells: {
              style: {
                    fontWeight: "bold",
                    fontSize: "15px",
                    justifyContent: "center"
              },
        },
        cells: {
              style: {
                    fontSize: "16px",
                    justifyContent: "center"
              }
        }
  };
   
    // ----------Search filter----------

    const datatable = data.filter(
        (item: any) =>
            JSON.stringify(item)
                .toLowerCase()
                .indexOf(filterText.toLowerCase()) !== -1
    );

    const paginationComponentOptions = {
        selectAllRowsItem: true,
        selectAllRowsItemText: "ALL"
    };
    const subHeaderComponent = useMemo(() => {
        const handleClear = () => {
            if (filterText) {
                setResetPaginationToggle(!resetPaginationToggle);
                setFilterText("");
            }

        };

        return (
            <div style={{ display: "flex" }}>
                <div style={{ display: "flex" }}>
                    <div className="form-group form-focus row">
                        <IonInput type="text" className="form-control floating" onIonChange={(e: any) => setFilterText(e.target.value)}
                            value={filterText} placeholder="Search" />
                        <label className="focus-label">Search</label>
                    </div>
                    <button type="button" style={{ backgroundColor: "orange", width: "45px", marginTop: "4px", height: "40px", position: 'absolute' }} onClick={handleClear}>X</button>
                </div>
            </div>
        )

    }, [filterText, resetPaginationToggle]);

    const back = () => {
        history.goBack();
    }
    return (
        <IonPage>
            <Head />
            <Sidebar />
            <IonContent>
                <div className="page-wrapper">
                    <div className="page-header">
                        <div className="content container-fluid">
                            <div className="row align-items-center">
                                <div className="col">
                                    <h3 className="page-title" style={{ fontWeight: "bold" }}>
                                    <i className="fa fa-arrow-left" onClick={back} style={{ color: "black", cursor: "pointer", marginRight: "5px" }} />
                                        Leave - Report</h3>
                                </div>
                            </div>
                            <div className="row filter-row" style={{ marginTop: "3%" }}>
                                <div>
                                    <form className="row addmore">
                                        <div className="form-group col-md-3">
                                            <label style={{ fontWeight: "bold" }}>
                                                Business Unit
                                            </label>
                                            <div>
                                                <Select
                                                    options={options}
                                                    value={options.find((option) => option.value === business) || null}
                                                    onChange={handleBusinessUnitChange}
                                                    onInputChange={handleInputChange}
                                                    onMenuOpen={handleMenuOpen}
                                                    onMenuClose={handleMenuClose}
                                                    onFocus={handleFocus}
                                                    onBlur={handleBlur}
                                                    menuIsOpen={menuIsOpen}
                                                    isSearchable
                                                    placeholder={<Placeholder />}
                                                    components={{
                                                        DropdownIndicator: DropdownIndicator,
                                                    }}
                                                    className="custom-select2"
                                                />
                                            </div>

                                        </div>


                                        <div className="col-sm-6 col-md-3">
                                            <div className="form-group">
                                                <label style={{ fontWeight: "bold" }}> From Date<span className="text-danger">*</span></label>
                                                <div>
                                                    <IonInput onIonChange={(e: any) => setFromDate(e.detail.value)} type="date" className="form-control datetimepicker" />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-sm-6 col-md-3">
                                            <div className="form-group">
                                                <label style={{ fontWeight: "bold" }}> To date <span className="text-danger">*</span></label>
                                                <div>
                                                    <IonInput onIonChange={(e: any) => setToDate(e.detail.value)} type="date" className="form-control datetimepicker" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-sm-6 col-md-3">
                                            <div className="form-group">
                                                <label style={{ fontWeight: "bold" }}> Leave Type <span className="text-danger">*</span></label>
                                                <div>
                                                    <Select
                                                        options={option1}
                                                        value={option1.find((option: any) => option.value === leave) || null}
                                                        onChange={handleLeaveChange}
                                                        onInputChange={handleInputChange1}
                                                        onMenuOpen={handleMenuOpen1}
                                                        onMenuClose={handleMenuClose1}
                                                        onFocus={handleFocus1}
                                                        onBlur={handleBlur1}
                                                        menuIsOpen={menuIsOpen1}
                                                        isSearchable
                                                        placeholder={<Placeholder1 />}
                                                        components={{
                                                            DropdownIndicator: DropdownIndicator1,
                                                        }}
                                                        className="custom-select3"
                                                    />
                                                </div>
                                            </div>

                                        </div>
                                        <div className="col-sm-6 col-md-3" style={{ display: 'flex', alignSelf: 'center', justifySelf: 'center' }}>
                                            <button type="button" onClick={handleSearch} className="btn btn-orange btn-block w-100">
                                               View Report
                                             </button>
                                        </div>

                                        <div className="col-sm-6 col-md-3" style={{ display: 'flex', alignSelf: 'center', justifySelf: 'center' }}>
                                            <button type="button" onClick={Leavepdf} className="btn btn-success btn-block w-100">
                                                Generate Pdf
                                            </button>
                                        </div>
                                    </form>
                                </div>
                                {isLoading && (
                                <div
                                    style={{
                                        position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(255, 255, 255, 0.8)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999
                                    }}
                                >
                                    <div >
                                        <IonSpinner style={{
                                            width: "40px",
                                            height: "40px",
                                            color: "#ff8a53"
                                        }} name="lines" />
                                    </div>
                                </div>
                            )}
                              
                            </div>
                            {showDataTable && (
                                <div className="table-responsive" style={{ marginTop: '2%' }}>
                                    <DataTable
                                        className="table-responsive"
                                        columns={columns}
                                        data={datatable}
                                        pagination
                                        paginationPerPage={10}
                                        paginationComponentOptions={paginationComponentOptions}
                                        paginationRowsPerPageOptions={[10, 20, 30]}
                                        subHeader
                                        subHeaderComponent={subHeaderComponent}
                                        customStyles={customStyles}
                                    />
                            
                                </div>
                                    )}
                        </div>
                    </div>

                </div>


            </IonContent>
        </IonPage>
    )
}

export default LeaveReport